<template>
  <div>
    <template>
      <v-stepper v-model="e6" vertical width="95%" class="mx-auto">
        <v-stepper-step :complete="e6 > 1" step="1" color="third">
          <div class="text-h6">Additional Information Section</div>
          <small class="mt-1">
            <v-icon small color="green">
              mdi-check-circle-outline
            </v-icon>
            {{ getScoreBoard.info.complete }} complete section(s)
          </small>
          <small class="mt-1" v-if="!!getScoreBoard.info.incomplete">
            <v-icon small color="orange">
              mdi-alert-circle-outline
            </v-icon>
            {{ getScoreBoard.info.incomplete }} incomplete section(s)
          </small>
        </v-stepper-step>

        <v-stepper-content step="1">
          <v-card class="mx-auto" tile>
            <v-list shaped>
              <v-subheader>Subsections:</v-subheader>
              <v-list-item-group color="primary">
                <v-list-item v-for="(subsection, i) in subsections" :key="i" @click="() => selectedSection(i)">
                  <v-list-item-icon>
                    <v-badge v-if="subsection.count > 0" color="first" :content="subsection.count" bordered offset-x="8"
                      offset-y="8">
                      <v-icon color="orange">
                        mdi-alert-circle
                      </v-icon>
                    </v-badge>
                    <v-icon v-else color="second">
                      mdi-checkbox-marked-circle
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="subsection.name"></v-list-item-title>
                    <v-list-item-subtitle class="first--text font-italic" v-if="subsection.errors.length > 0">
                      <b>Missing Fields:</b> {{ subsection.errors.join(', ') }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>

            <v-card-actions>
              <v-btn color="third" class="white--text" @click="e6 = 2" :disabled="!!getScoreBoard.info.incomplete">
                Continue
              </v-btn>
            </v-card-actions>
            <small v-if="!!getScoreBoard.info.incomplete" class="mx-2 font-italic font-weight-light">
              Hint: You must complete the section before proceeding.
            </small>
          </v-card>
        </v-stepper-content>

        <v-stepper-step :complete="e6 > 2" step="2" color="third">
          <div class="text-h6">Products Section</div>
          <small class="mt-1">
            <v-icon small color="green">
              mdi-check-circle-outline
            </v-icon>
            {{ getScoreBoard.products.complete }} complete product(s)
          </small>
          <small class="mt-1" v-if="!!getScoreBoard.products.incomplete">
            <v-icon small color="orange">
              mdi-alert-circle-outline
            </v-icon>
            {{ getScoreBoard.products.incomplete }} incomplete product(s)
          </small>
        </v-stepper-step>

        <!-- Products -->
        <v-stepper-content step="2">
          <v-card class="mx-auto" tile>
            <v-list shaped>
              <v-subheader>Products List:</v-subheader>
              <v-list-item style="border-style: solid;" v-for="(product, i) in products" :key="i">
                <v-col>
                  <v-list-item-content>
                    <v-list-group :value="!isProductComplete(product)" no-action sub-group>
                      <template v-slot:activator>
                        <v-list-item-icon>
                          <v-icon v-if="!isProductComplete(product)" color="orange">
                            mdi-alert-circle
                          </v-icon>
                          <v-icon v-else color="second">
                            mdi-checkbox-marked-circle
                          </v-icon>
                        </v-list-item-icon>
                        <v-list-item-content class="ml-2">
                          <v-list-item-title class="font-weight-bold" v-text="product.product_name"></v-list-item-title>
                        </v-list-item-content>
                      </template>

                      <v-list-item>
                        <v-list-item-group color="primary">
                          <v-list-item v-for="(tab, j) in product.tabs" :key="j"
                            @click="() => selectedSection(j, product.product_id, product.tabs)">
                            <v-list-item-icon>
                              <v-badge v-if="tab.count > 0" color="first" :content="tab.count" bordered offset-x="8"
                                offset-y="8">
                                <v-icon color="orange">
                                  mdi-alert-circle
                                </v-icon>
                              </v-badge>
                              <v-icon v-else color="second">
                                mdi-checkbox-marked-circle
                              </v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                              <v-list-item-title v-text="tab.name"></v-list-item-title>
                              <v-list-item-subtitle class="first--text font-italic" v-if="tab.errors.length > 0">
                                <b>Missing Fields:</b> {{ tab.errors.join(', ') }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list-item>
                    </v-list-group>
                  </v-list-item-content>

                  <div v-if="product.order_type === 'ptp' || product.order_type === 'evpl'">
                    <ReviewItem label="What type of traffic will be going across this point to point circuit?"
                      :value="getProductInfo(product.product_id).traffic" />
                    <ReviewItem label="Signature" :value="getProductInfo(product.product_id).traffic_signature" />
                    <ReviewItem label="Signature Acceptance"
                      :value="getProductInfo(product.product_id).traffic_signature_certified" />
                  </div>
                  <div v-if="product.is_voice">
                    <ReviewItem label="Are you moving any numbers from your previous provider?"
                      :value="getProductInfo(product.product_id).porting" />

                    <div v-if="getProductInfo(product.product_id).porting === 'y'">
                      <ReviewItem label="Are you porting any tollfree numbers from your previous provider?"
                        :value="getProductInfo(product.product_id).tf_numbers" />
                    </div>
                    <ReviewItem label="Do you need any new numbers?"
                      :value="getProductInfo(product.product_id).new_numbers_requested" />
                    <ReviewItem v-if="getProductInfo(product.product_id).new_numbers_requested"
                      label="How many new phone numbers?"
                      :value="getProductInfo(product.product_id).quantity_numbers" />

                    <ReviewItem label="Do you want to enable Canada Calling?"
                      :value="getProductInfo(product.product_id).canada_calling" />

                    <ReviewItem label="Do you want to enable International Calling?"
                      :value="getProductInfo(product.product_id).international_calling" />
                  </div>

                  <div v-if="product.order_type === 'dpri' || product.order_type === 'pri'">
                    <ReviewItem label="What is your PRI Variant?" :value="isdnValue(product.product_id)" />
                    <ReviewItem label="What are your outpulsed digits?" :value="readableOPD(product.product_id)" />
                    <ReviewItem label="Will your PBX control the outpulsing of caller ID number?"
                      :value="readablePBXControl(product.product_id)" />
                  </div>

                </v-col>
              </v-list-item>
            </v-list>
            <v-card-actions>
              <v-btn color="third" class="white--text" @click="validate"
                :disabled="getScoreBoard.products.incomplete > 0">
                Next
              </v-btn>
              <v-btn class="mx-2" text @click="e6 = 1">Back</v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="3">
          <v-card class="mx-auto mb-7">
            <v-card-text>
              <v-container>
                <div class="text-h4">Order Finalization</div>
                <p>You have completed the additional information form. Submit the order</p>
                <!-- <ESignature
          v-model="general.signature_name"
          :accepted.sync="general.forms_certified"
          acceptText="By signing you confirm the accuracy of the information you have provided."
        /> -->

                <v-btn class="mt-2" color="success" @click="submitOrder">
                  Submit Order
                </v-btn>
              </v-container>
            </v-card-text>
          </v-card>
        </v-stepper-content>
      </v-stepper>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import _ from 'lodash';
import ReviewItem from '@/components/ReviewItem.vue';

export default {
  name: 'ReviewFrame',
  data: () => ({
    e6: 1,
    subsections: [],
    formData: {},
    products: [],
    allStates: [
      'AL', 'AR', 'AZ', 'CA', 'CO', 'CT', 'DC', 'FL', 'GA',
      'HI', 'ID', 'IL', 'IA', 'KS', 'KY', 'ME', 'MD', 'MI',
      'MN', 'MO', 'NE', 'NV', 'NJ', 'NM', 'NC', 'ND', 'OH',
      'OK', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT',
      'WA', 'WI',
    ],
    isdnKey: {
      1: "Standard/NI2",
      2: "Custom/AT&T/5ESS",
      3: "Custom/DMS100",
      4: "Other",
      5: "Unknown",
    },
  }),
  mounted() {
    this.formData = _.cloneDeep(this.getFormData.general);
    const tabs = _.cloneDeep(this.addInfoSubTabs);
    tabs.pop(); // removes review tab
    this.subsections = tabs.map((tab) => ({
      ...tab,
      ...this.getMissingItems(tab),
    }));

    // Products
    const products = _.cloneDeep(this.getProducts);
    this.products = products.map((product) => {
      let productTabs = this.productSubTabs(product);
      // productTabs.pop(); // remove review section
      productTabs = productTabs.map((tab) => ({
        ...tab,
        ...this.getMissingItems(tab, this.getProductInfo(product.product_id), product),
      }));

      return {
        ...product,
        tabs: productTabs,
      };
    });
  },
  methods: {
    ...mapActions([
      'setSubTab',
      'setMainTab',
      'setCurrentProductId',
      'nextSubTab',
      'setReadyToSignStatus',
      'syncFormData',
      'saveProgress',
    ]),
    validate() {
      let valid = false;
      if (this.getScoreBoard.products.incomplete === 0) {
        valid = true;
        this.readyToSubmit = true;
        this.e6 += 1;
        // this.setMainTab('signAndSubmit');
      }
      this.setReadyToSignStatus(valid);
    },
    rdd() {
      let count = 0;
      const errors = [];

      if (!this.formData.has_due_date) {
        count += 1;
      } else if (this.formData.has_due_date === 'y') {
        if (!this.formData.requested_due_date) count += 1;
      }

      return {
        count,
        errors,
      };
    },
    tax_qs() {
      let count = 0;
      const errors = [];

      if (!this.formData.usf_charge) {
        count += 1;
        errors.push('USF Exempt');
      }

      return {
        count,
        errors,
      };
    },
    usf_form() {
      let count = 0;
      const errors = [];

      if (!this.formData.company_name) {
        count += 1;
        errors.push('Company Name');
      }
      if (!this.formData.usf_address) {
        count += 1;
        errors.push('Address');
      }
      if (!this.formData.usf_city) {
        count += 1;
        errors.push('City');
      }
      if (!this.formData.usf_state) {
        count += 1;
        errors.push('State');
      }
      if (!this.formData.usf_zip) {
        count += 1;
        errors.push('Zip');
      }
      if (!this.formData.exempt_account) {
        count += 1;
        errors.push('Exempt Account');
      }
      if (!this.formData.filer_id) {
        count += 1;
        errors.push('FCC 499 Filer ID');
      }

      return {
        count,
        errors,
      };
    },
    mi_access_charges() {
      let count = 0;
      const errors = [];

      if (!this.formData.stateaccesstax_company_name) {
        count += 1;
        errors.push('Company Name');
      }
      if (!this.formData.stateaccesstax_accounts_exempt) {
        count += 1;
        errors.push('Accounts Exempt');
      }
      if (!this.formData.stateaccesstax_registration_number) {
        count += 1;
        errors.push('State Registration Number');
      }
      if (!this.formData.stateaccesstax_sig_name) {
        count += 1;
        errors.push('Signature');
      }

      return {
        count,
        errors,
      };
    },
    statetax_form() {
      let count = 0;
      const errors = [];

      if (!this.formData.statetax_name_of_firm) {
        count += 1;
        errors.push('Company Name');
      }
      if (!this.formData.statetax_address) {
        count += 1;
        errors.push('Address');
      }
      if (!this.formData.statetax_city) {
        count += 1;
        errors.push('City');
      }
      if (!this.formData.statetax_state) {
        count += 1;
        errors.push('State');
      }
      if (!this.formData.statetax_zip) {
        count += 1;
        errors.push('Zip');
      }
      if (!this.formData.statetax_company_type) {
        count += 1;
        errors.push('Company Type');
      }
      if (this.formData.statetax_company_type === 'other' && !this.formData.statetax_other_type) {
        count += 1;
        errors.push('Company Type (Specify)');
      }
      if (!this.formData.statetax_desc_of_business) {
        count += 1;
        errors.push('Description of business');
      }
      if (!this.formData.statetax_purchased_desc) {
        count += 1;
        errors.push('Description of purchased items');
      }
      if (!this.addedStateOrNot) {
        count += 1;
        errors.push('Exemption ID');
      }
      if (!this.formData.statetax_sig_name) {
        count += 1;
        errors.push('Authorized Customer Signature');
      }
      if (!this.formData.statetax_certified || this.formData.statetax_certified === 'n') {
        count += 1;
        errors.push('Terms Accept');
      }

      /* eslint-disable-next-line */
      const idx = _.findIndex(this.formData.contacts, (contact) => {
        return _.findIndex(contact.roles, (role) => role === 'State Tax Exemption Contact') !== -1;
      });
      if (idx === -1) {
        count += 1;
        errors.push('Authorized Contact');
      }

      return {
        count,
        errors,
      };
    },
    mi911_form() {
      let count = 0;
      const errors = [];

      if (!this.formData.emergencytax_company_name) {
        count += 1;
        errors.push('Company Name');
      }
      if (!this.formData.emergencytax_address) {
        count += 1;
        errors.push('Address');
      }
      if (!this.formData.emergencytax_city) {
        count += 1;
        errors.push('City');
      }
      if (!this.formData.emergencytax_state) {
        count += 1;
        errors.push('State');
      }
      if (!this.formData.emergencytax_zip) {
        count += 1;
        errors.push('Zip');
      }
      if (!this.formData.emergencytax_sig_name) {
        count += 1;
        errors.push('Authorized Customer Signature');
      }
      if (!this.formData.emergencytax_certified || this.formData.emergencytax_certified === 'n') {
        count += 1;
        errors.push('Terms Accept');
      }

      /* eslint-disable-next-line */
      const idx = _.findIndex(this.formData.contacts, (contact) => {
        return _.findIndex(contact.roles, (role) => role === 'MI911 Fee Exemption Contact') !== -1;
      });
      if (idx === -1) {
        count += 1;
        errors.push('Authorized Contact');
      }

      return {
        count,
        errors,
      };
    },
    fed_form() {
      let count = 0;
      const errors = [];

      if (!this.formData.fedtax_company_name) {
        count += 1;
        errors.push('Company Name');
      }
      if (!this.formData.fedtax_address) {
        count += 1;
        errors.push('Address');
      }
      if (!this.formData.fedtax_city) {
        count += 1;
        errors.push('City');
      }
      if (!this.formData.fedtax_state) {
        count += 1;
        errors.push('State');
      }
      if (!this.formData.fedtax_zip) {
        count += 1;
        errors.push('Zip');
      }
      if (!this.formData.fedtax_accounts_exempt) {
        count += 1;
        errors.push('Exempt Accounts');
      }
      if (!this.formData.fedtax_exemption_type) {
        count += 1;
        errors.push('Exemption Types');
      }
      if (!this.formData.fedtax_exemption_provision) {
        count += 1;
        errors.push('Exemption Provision');
      }
      if (!this.formData.fedtax_sig_name) {
        count += 1;
        errors.push('Authorized Customer Signature');
      }
      if (!this.formData.fedtax_accepted || this.formData.fedtax_accepted === 'n') {
        count += 1;
        errors.push('Accepted Terms');
      }

      return {
        count,
        errors,
      };
    },
    contacts() {
      let count = 0;
      const errors = [];
      /*
        const hasColocationProduct = this.getProducts.filter((product) =>
          product.order_type === 'col').length > 0;
        const hasVoiceProduct = this.getProducts.filter((product) => product.is_voice).length > 0;
        console.log({ hasColocationProduct, hasVoiceProduct });
      */
      /* ****
        ALL required roles:
          * case 'Main Contact'
          * case 'Local Contact'
          * case 'Emergency Contact'
          * case 'Portal Admin'
          * case 'Primary Voice Contact'
          * case 'Order Notifications'
      **** */

      if (
        !this.formData.lcon_name
        && !this.formData.lcon_email
        && !this.formData.lcon_phone
      ) {
        count += 1;
        errors.push('Local Contact');
      }

      if (
        !this.formData.notif_name?.length
        && !this.formData.notif_email?.length
        && !this.formData.notif_phone?.length
      ) {
        count += 1;
        errors.push('Order Notifications Contact');
      }

      // required roles for retail
      if (this.isRetail) {
        if (!this.formData.mcp_name && !this.formData.mcp_email && !this.formData.mcp_phone) {
          count += 1;
          errors.push('Main Contact');
        }

        // if (!this.formData.emergency_contact_email && !this.formData.ec_office) {
        //   count += 1;
        //   errors.push('Emergency Contact');
        // }

        if (!this.formData.portal_name
          && !this.formData.portal_email
          && !this.formData.portal_phone) {
          count += 1;
          errors.push('Portal Admin Contact');
        }
      }

      return {
        count,
        errors,
      };
    },
    vendor_info() {
      let count = 0;
      const errors = [];
      if (!this.formData.has_vendor) {
        count += 1;
        errors.push('Uses IT Vendor');
      }
      if (this.formData.has_vendor === 'y') {
        if (!this.formData.vendor_company_name) {
          count += 1;
          errors.push('IT Vendor Company Name');
        }
        if (!this.formData.vendor_contact_name
          && !this.formData.vendor_contact_email
          && !this.formData.vendor_contact_number) {
          count += 1;
          errors.push('IT Vendor Contact');
        }
        if (!this.formData.vendor_company_number) {
          count += 1;
          errors.push('IT Vendor Company Phone Number');
        }
      }
      return {
        count,
        errors,
      };
    },
    ap_billing() {
      let count = 0;
      const errors = [];
      if (!this.formData.ap_contact
        && !this.formData.ap_email
        && !this.formData.ap_phone) {
        count += 1;
        errors.push('Billing Contact');
      }
      if (!this.formData.ap_address) {
        count += 1;
        errors.push('Billing Address');
      }
      if (!this.formData.ap_name) {
        count += 1;
        errors.push('Billing Company Name');
      }
      if (this.formData.purchase_order_required) {
        if (!this.formData.purchase_order) {
          count += 1;
          errors.push('Purchase Order Number');
        }
      }
      return {
        count,
        errors,
      };
    },
    pbx_vendor_info() {
      let count = 0;
      const errors = [];
      if (!this.formData.has_pbx_vendor) {
        count += 1;
        errors.push('Uses PBX - Phone System Vendor');
      }
      if (this.formData.has_pbx_vendor === 'y') {
        if (!this.formData.pbx_vendor_company_name) {
          count += 1;
          errors.push('PBX Vendor Company Name');
        }
        if (!this.formData.pbx_vendor_contact_name
          && !this.formData.pbx_vendor_contact_email
          && !this.formData.pbx_vendor_contact_number) {
          count += 1;
          errors.push('PBX Vendor Contact');
        }
        if (!this.formData.pbx_vendor_company_number) {
          count += 1;
          errors.push('PBX Vendor Company Phone Number');
        }
      }
      return {
        count,
        errors,
      };
    },
    handoff(info) {
      let count = 0;
      const errors = [];
      if (!info.gig_connections) {
        count += 1;
        errors.push('Handoff');
      }

      return {
        count,
        errors,
      };
    },
    ips(product) {
      let count = 0;
      const errors = [];
      if (this.currentIPs(product) === undefined) {
        count += 1;
        errors.push('IP Addresses Requested');
      }

      return {
        count,
        errors,
      };
    },
    ipj_form(info) {
      let count = 0;
      const errors = [];
      if (!info.ip_request?.length) {
        count += 1;
        errors.push('Number and Description of IP Requested');
      }
      if (!info.arin) {
        count += 1;
        errors.push('ARIN.NET Account');
      }
      if (info.arin && info.arin === 'y') {
        if (!info.arin_id && !info.arin_as) {
          count += 1;
          errors.push('ARIN.net Account Details');
        }
      }

      return {
        count,
        errors,
      };
    },
    outlet_type(tab, info, productId) {
      const tabNth = tab.id.charAt(tab.id.length - 1);
      let count = 0;
      const errors = [];
      if (info.power_outlet_type) {
        this.getProducts.forEach((product) => {
          if (product.product_id === productId) {
            if (product.addons[tabNth].value !== '50ADC' && info.power_outlet_type[tabNth] == null) {
              count += 1;
              errors.push('Power Outlet Type');
            }
          }
        });
      } else {
        count += 1;
        errors.push('Power Outlet Type');
      }
      return {
        count,
        errors,
      };
    },
    vlan(info) {
      let count = 0;
      const errors = [];
      if (!info.vlan_preference) {
        count += 1;
        errors.push('VLAN Preference');
      }

      return {
        count,
        errors,
      };
    },
    traffic_type(info) {
      let count = 0;
      const errors = [];
      if (!info.traffic) {
        count += 1;
        errors.push('Traffic Type');
      }
      // if (!info.traffic_initials) {
      //   count += 1;
      //   errors.push('Traffic Initials');
      // }

      if (!info.traffic_signature) {
        count += 1;
        errors.push('Traffic Initials');
      }

      if (info.traffic_signature_certified !== 'y') {
        count += 1;
        errors.push('Certify the Traffic Signature');
      }

      return {
        count,
        errors,
      };
    },
    pri_questions(info) {
      let count = 0;
      const errors = [];
      if (info.isdn === undefined) {
        count += 1;
        errors.push('PRI Variant');
      }
      if (info.opd === undefined) {
        count += 1;
        errors.push('Outpulsed Digits');
      }
      if (!info.pbx_control) {
        count += 1;
        errors.push('PBX Control');
      }

      return {
        count,
        errors,
      };
    },
    loa(info) {
      let count = 0;
      const errors = [];
      if (!info.porting) {
        count += 1;
        errors.push('Porting Numbers');
      }
      // console.log(this.invoiceFiles);
      // if (info.porting && info.porting === 'y' && this.invoiceFiles.length === 0) {
      //   if (!info.listing_phone) {
      //     count += 1;
      //     errors.push('Billing Telephone Number');
      //   }
      //   if (!info.loa_phone) {
      //     count += 1;
      //     errors.push('Porting Numbers');
      //   }
      //   if (!info.listing_company_name) {
      //     count += 1;
      //     errors.push('Business Name');
      //   }
      //   if (!info.loa_address) {
      //     count += 1;
      //     errors.push('Company Address');
      //   }
      //   if (!info.loa_city) {
      //     count += 1;
      //     errors.push('Company City');
      //   }
      //   if (!info.loa_state) {
      //     count += 1;
      //     errors.push('Company State');
      //   }
      //   if (!info.loa_zip) {
      //     count += 1;
      //     errors.push('Company Zip');
      //   }
      //   if (!info.requested_port_date) {
      //     count += 1;
      //     errors.push('Requested Port Date');
      //   }
      //   if (!info.loa_name) {
      //     count += 1;
      //     errors.push('Authorized Customer Signature');
      //   }
      //   if (!info.loa_accepted || info.loa_accepted === 'n') {
      //     count += 1;
      //     errors.push('Terms Accept');
      //   }
      // }

      return {
        count,
        errors,
      };
    },
    new_numbers(info) {
      let count = 0;
      const errors = [];
      if (!info.new_numbers_requested) {
        count += 1;
        errors.push('New Numbers Requested');
      }
      if (info.new_numbers_requested && info.new_numbers_requested === 'y') {
        if (info.quantity_numbers === undefined) {
          count += 1;
          errors.push('New Numbers Quantity');
        }
      }

      return {
        count,
        errors,
      };
    },
    resp_org(info) {
      let count = 0;
      const errors = [];

      if (!info.tf_numbers) {
        count += 1;
        errors.push('Porting Tollfree Numbers');
      }
      if (info.tf_numbers && info.tf_numbers === 'y') {
        if (!info.tf_phone?.length) {
          count += 1;
          errors.push('Tollfree Porting Numbers');
        }
        if (!info.tf_company_name) {
          count += 1;
          errors.push('Company Name');
        }
        if (!info.tf_address) {
          count += 1;
          errors.push('Company Address');
        }
        if (!info.tf_city) {
          count += 1;
          errors.push('Company City');
        }
        if (!info.tf_state) {
          count += 1;
          errors.push('Company State');
        }
        if (!info.tf_zip) {
          count += 1;
          errors.push('Company Zip');
        }
        /*
        if (!info.tfc_fax) {
          count += 1;
          errors.push('Company Fax');
        }
        */
        if (!info.tfc_auth_contact) {
          count += 1;
          errors.push('Authorized Resp Org Contact');
        }
        if (!info.tf_sig_name) {
          count += 1;
          errors.push('Authorized Customer Signature');
        }
        if (!info.tf_accepted) {
          count += 1;
          errors.push('Accepted Terms');
        }
      }

      return {
        count,
        errors,
      };
    },
    wpl_form(info) {
      let count = 0;
      const errors = [];

      if (!info.white_page_listing) {
        count += 1;
        errors.push('White Page Listing Request');
      }
      if (info.white_page_listing && info.white_page_listing === 'y') {
        if (!info.listing_company_name) {
          count += 1;
          errors.push('Company Name');
        }
        if (!info.listing_phone) {
          count += 1;
          errors.push('Company Phone Number');
        }
        if (!info.listing_address) {
          count += 1;
          errors.push('Company Address');
        }
        if (!info.listing_city) {
          count += 1;
          errors.push('Company City');
        }
        if (!info.listing_state) {
          count += 1;
          errors.push('Company State');
        }
        if (!info.listing_zip) {
          count += 1;
          errors.push('Company Zip');
        }
      }

      return {
        count,
        errors,
      };
    },
    caller_id(info) {
      let count = 0;
      const errors = [];

      if (!info.caller_id) {
        count += 1;
        errors.push('Caller Id Name');
      }

      return {
        count,
        errors,
      };
    },
    e911(info) {
      let count = 0;
      const errors = [];

      if (!info.e911_address) {
        count += 1;
        errors.push('E911 Location Address');
      }
      if (!info.e911_city) {
        count += 1;
        errors.push('E911 Location City');
      }
      if (!info.e911_state) {
        count += 1;
        errors.push('E911 Location State');
      }
      if (!info.e911_zip) {
        count += 1;
        errors.push('E911 Location Zip');
      }

      return {
        count,
        errors,
      };
    },
    emerg_failover_dest(info) {
      let count = 0;
      const errors = [];

      if (!info.emerg_failover_dest) {
        count += 1;
        errors.push('Emergency Failover Contact Number');
      }

      return {
        count,
        errors,
      };
    },
    international_canada_calling(info) {
      let count = 0;
      const errors = [];
      if (!info.international_calling) {
        count += 1;
        errors.push('Enable International Calling');
      }
      if (info.international_calling && info.international_calling === 'y') {
        if (!info.international_calling_inital) {
          count += 1;
          errors.push('Enable International Calling Initial');
        }
      }
      if (!info.canada_calling) {
        count += 1;
        errors.push('Enable Canada Calling');
      }
      if (info.canada_calling && info.canada_calling === 'y') {
        if (!info.canada_calling_inital) {
          count += 1;
          errors.push('Enable Canada Calling Initial');
        }
      }

      return {
        count,
        errors,
      };
    },
    getMissingItems(tab, info, product) {
      let output;
      if (product && product.order_web_type.type === 'renew') {
        return { count: 0, errors: [] }; // bypass review for renewals
      }

      if (/^outlet_type/.test(tab.id)) {
        output = this.outlet_type(tab, info, product.product_id);
      } else {
        switch (tab.id) {
          /* Additional Info */
          case 'rdd':
            output = this.rdd();
            break;
          case 'tax_qs':
            output = this.tax_qs();
            break;
          case 'usf_form':
            output = this.usf_form();
            break;
          case 'mi_access_charges':
            output = this.mi_access_charges();
            break;
          case 'statetax_form':
            output = this.statetax_form();
            break;
          case 'mi911_form':
            output = this.mi911_form();
            break;
          case 'fed_form':
            output = this.fed_form();
            break;
          case 'contacts':
            output = this.contacts();
            break;
          case 'ap_billing':
            output = this.ap_billing();
            break;
          case 'vendor_info':
            output = this.vendor_info();
            break;
          case 'pbx_vendor_info':
            output = this.pbx_vendor_info();
            break;
          /* /Additional Info */
          /* Products */
          case 'handoff':
            output = this.handoff(info);
            break;
          case 'ipj_form':
            output = this.ipj_form(info);
            break;
          case 'vlan':
            output = this.vlan(info);
            break;
          case 'traffic_type':
            output = this.traffic_type(info);
            break;
          case 'pri_questions':
            output = this.pri_questions(info);
            break;
          case 'loa':
            output = this.loa(info);
            break;
          case 'new_numbers':
            output = this.new_numbers(info);
            break;
          case 'resp_org':
            output = this.resp_org(info);
            break;
          case 'wpl_form':
            output = this.wpl_form(info);
            break;
          case 'caller_id':
            output = this.caller_id(info);
            break;
          case 'e911':
            output = this.e911(info);
            break;
          case 'emerg_failover_dest':
            output = this.emerg_failover_dest(info);
            break;
          case 'international_canada_calling':
            output = this.international_canada_calling(info);
            break;
          /* /Products */
          default:
            output = {
              errors: [],
              count: 0,
            };
            break;
        }
      }
      return output;
    },
    selectedSection(idx, id = null, tabs = []) {
      if (id) {
        this.setMainTab('products');
        this.setCurrentProductId(id);
        this.setSubTab(tabs[idx].id);
      } else {
        const tab = this.addInfoSubTabs[idx];
        this.setMainTab('additionalInfo');
        this.setSubTab(tab.id);
      }
    },
    isProductComplete(product) {
      const errorCount = product.tabs.filter((tab) => tab.errors.length > 0);
      if (errorCount.length > 0) {
        return false;
      }
      return true;
    },
    submitOrder() {
      const vm = this;
      vm.formData.completed = 'y';
      vm.sync();
      vm.isLoading = true;
      vm.saveProgress().then(() => {
        console.log('thank you');
      }).finally(() => {
        vm.isLoading = false;
      });
    },
    sync() {
      const vm = this;
      vm.syncFormData({
        mainKey: 'general',
        data: _.cloneDeep(vm.formData),
      });
    },
    isdnValue(productid) {
      const vm = this;
      return this.isdnKey[vm.getProductInfo(productid).isdn];
    },
    readableOPD(productid) {
      if (this.getProductInfo(productid).opd < 0) {
        return 'Unknown';
      }
      return this.getProductInfo(productid).opd;
    },
    readablePBXControl(productid) {
      const pbx = this.getProductInfo(productid).pbx_control;
      if (pbx === 'y') {
        return 'Yes';
      }
      if (pbx === 'n') {
        return 'No';
      }
      return 'Unknown';
    },
  },
  computed: {
    ...mapGetters([
      'isReady',
      'isRetail',
      'addInfoSubTabs',
      'productSubTabs',
      'getFormData',
      'getProducts',
      'getProductInfo',
      'currentIPs',
      'getAllFiles',
      'getProductSelected',
      'getProductInfo',
    ]),
    addedStateOrNot() {
      const vm = this;
      let added = false;
      _.forEach(vm.allStates, (state) => {
        if (vm.formData[`statetax_${state.toLowerCase()}_id`] != null) {
          added = true;
        }
      });
      return added;
    },
    getScoreBoard() {
      const score = {
        info: {
          complete: 0,
          incomplete: 0,
        },
        products: {
          complete: 0,
          incomplete: 0,
        },
      };
      // INFO section
      this.subsections.forEach((section) => {
        if (section.count > 0) {
          score.info.incomplete += 1;
        } else {
          score.info.complete += 1;
        }
      });

      // PRODUCT section
      this.products.forEach((product) => {
        const errorCount = product.tabs.filter((tab) => tab.errors.length > 0);
        if (errorCount.length > 0) {
          score.products.incomplete += 1;
        } else {
          score.products.complete += 1;
        }
      });
      return score;
    },
    invoiceFiles() {
      const vm = this;
      return _.filter(vm.getAllFiles, (file) => file.tags.field_name === 'loa_invoice');
    },
  },
  components: {
    ReviewItem,
  },
};
</script>
